/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFBreachSourceItem
 */
export interface CRSFBreachSourceItem {
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFBreachSourceItem
     */
    features: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFBreachSourceItem
     */
    fullname?: string;
}

/**
 * Check if a given object implements the CRSFBreachSourceItem interface.
 */
export function instanceOfCRSFBreachSourceItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "features" in value;

    return isInstance;
}

export function CRSFBreachSourceItemFromJSON(json: any): CRSFBreachSourceItem {
    return CRSFBreachSourceItemFromJSONTyped(json, false);
}

export function CRSFBreachSourceItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFBreachSourceItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'features': json['features'],
        'fullname': !exists(json, 'fullname') ? undefined : json['fullname'],
    };
}

export function CRSFBreachSourceItemToJSON(value?: CRSFBreachSourceItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'features': value.features,
        'fullname': value.fullname,
    };
}

